import React from 'react';
import PropTypes from 'prop-types';

// import assets
import './dateSharingModule.scss';

import '../../../../assets/icons/Icon_Facebook.svg';
import '../../../../assets/icons/Icon_Twitter.svg';
import '../../../../assets/icons/Icon_Instagram.svg';
import '../../../../assets/icons/Icon_Mail.svg';
import '../../../../assets/icons/Icon_WhatsApp.svg';

const DateSharingModuleView = props => (
  <div className="m-article-module">
    <div className={'m-datesharing-module'}>
      <div className={'m-datesharing-module__datetext'}>
        {props.text} {new Date(props.formatteddate).toLocaleDateString('en-us', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        },
        )}
      </div>
      <div className={'m-datesharing-module__social-wrapper'}>
        { props.facebook ? <a
          className={'m-datesharing-module__social-facebook'}
          href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
          target={'_blank'}
        >
          <div className={'m-datesharing-module__logo'}>
            <svg>
              <use xlinkHref="#Icon_Facebook" />
            </svg>
          </div>
          <div className={'m-datesharing-module__socialname'}>Facebook</div>
        </a> : null }
        { props.twitter ? <a
          className={'m-datesharing-module__social-twitter'}
          href={`https://twitter.com/intent/tweet/?url=${window.location.href}`}
          target={'_blank'}
          rel="noopener"
        >
          <div className={'m-datesharing-module__logo'}>
            <svg>
              <use xlinkHref="#Icon_Twitter" />
            </svg>
          </div>
          <div className={'m-datesharing-module__socialname'}>Twitter</div>
        </a> : null}
        { props.mail ? <a
          className={'m-datesharing-module__social-mail'}
          href={`mailto:recipient@example.com?subject=Look what i have just found on Zeiss Lenspire&body=${window.location.href}`}
          target={'_blank'}
          rel="noopener"
        >
          <div className={'m-datesharing-module__logo'}>
            <svg>
              <use xlinkHref="#Icon_Mail" />
            </svg>
          </div>
          <div className={'m-datesharing-module__socialname'}>Email</div>
        </a> : null }
        { props.whatsapp ? <a
          className={'m-datesharing-module__social-whatsapp'}
          href={`https://api.whatsapp.com/send?text=${window.location.href}`}
          target={'_blank'}
          rel="noopener"
        >
          <div className={'m-datesharing-module__logo'}>
            <svg>
              <use xlinkHref="#Icon_WhatsApp" />
            </svg>
          </div>
          <div className={'m-datesharing-module__socialname'}>WhatsApp</div>
        </a> : null }
      </div>
    </div>
  </div>
);

DateSharingModuleView.propTypes = {
  text: PropTypes.string,
  formatteddate: PropTypes.string,
  facebook: PropTypes.bool,
  twitter: PropTypes.bool,
  mail: PropTypes.bool,
  whatsapp: PropTypes.bool,
};

DateSharingModuleView.defaultProps = {
  text: '',
  formatteddate: '',
  facebook: '',
  twitter: '',
  mail: '',
  whatsapp: '',
};

export default DateSharingModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/DateSharingModule/DateSharingModuleView.jsx